import { db } from '@config/firebase.config';

const consolidatedDaysRef = (teamId) =>
  db
    .collection('teamDatabase')
    .doc(teamId)
    .collection('consolidatedData')
    .doc('days')
    .collection('dateId');

/** Fetch one consolidated day doc. Returns null if not yet computed. */
export async function fetchConsolidatedDay(teamId, dateId) {
  const snap = await consolidatedDaysRef(teamId).doc(dateId).get();
  return snap.exists ? snap.data() : null;
}

/**
 * Fetch the last `limitCount` consolidated day docs, oldest-first.
 * Used for trend charts (7-day window by default).
 */
export async function fetchConsolidatedDays(teamId, limitCount = 7) {
  const snap = await consolidatedDaysRef(teamId)
    .orderBy('dateId', 'desc')
    .limit(limitCount)
    .get();
  return snap.docs.map((d) => d.data()).reverse();
}
